module.exports = __webpack_public_path__ + "img/mac.3ee29cac.png";